import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { SizeTracker } from '../../../../../common/SizeTracker'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import TextEllipsis from '../../../../../common/textEllipsis'
import { selectLoadingImportCompany } from '../../store/slice'
import { downloadTemplate, postImportExcel } from '../../store/thunk'
import classes from '../index.module.scss'
import { ValidateUpload } from './ValidateUpload'

export const GroupUploadFile = () => {
  const dispatch = useDispatch()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const isLoadingImport = useSelector(selectLoadingImportCompany)

  const [fileUpload, setFileUpload] = useState(null)
  const [fileName, setFileName] = useState('')
  const [invalidFormatFile, setInvalidFormatFile] = useState(false)

  const inputElement = document.querySelector('#importFile')
  const textInput = UseI18n('library.detailsPortfolios.NO_CHOOSE_FILE')

  const handleDownloadTemplate = () => {
    dispatch(downloadTemplate())
  }

  const handleSelectFile = (event) => {
    const validExts = ['.xlsx', '.xls']
    const fileExt = event.target.files[0].name.substring(
      event.target.files[0].name.lastIndexOf('.'),
    )
    if (!validExts.includes(fileExt)) {
      setInvalidFormatFile(true)
    } else {
      setFileUpload(event.target.files[0])
      setFileName(event.target.files[0]?.name)
      setInvalidFormatFile(false)
    }
  }

  const handleUpload = () => {
    if (fileUpload) {
      let bodyFormData = new FormData()
      bodyFormData.append('file', fileUpload)
      dispatch(postImportExcel({ id, bodyFormData }))
        .unwrap()
        .then(() => {
          setFileUpload(null)
          setFileName('')
          inputElement.value = null
        })
        .catch(() => {})
    }
    return
  }

  return (
    <div>
      <>
        <div className={classes.groupUpload}>
          <div className="dFlex flex1">
            <Element
              elementName="label"
              style={{
                color: '#FFFFFF',
                padding: '0 24px',
                backgroundColor: '#2C73E8',
                borderRadius: '4px',
                textAlign: 'center',
              }}
              htmlFor="importFile"
              className="whiteSpaceNowrap cursorPointer dFlex justifyContentCenter alignItemsCenter"
            >
              <Translate value="library.detailsPortfolios.CHOOSE_FILE" />
            </Element>
            <Element
              style={{ backgroundColor: '#FFFFFF' }}
              className={classes.inputChooseFile}
            >
              <Icon
                className="icon-insert-file"
                style={{ color: '#9C9C9C', fontSize: 14 }}
              />
              <SizeTracker
                bottomClassName="flex1"
                renderBottomComponent={(size) => {
                  return (
                    <TextEllipsis
                      text={fileName ? fileName : textInput}
                      isI18n={false}
                      appendStyle={{
                        color: '#9C9C9C',
                        width: size?.width,
                      }}
                      zIndexTooltip={15}
                    />
                  )
                }}
              />
            </Element>
          </div>
          <div>
            <Element
              className={classes.upload}
              style={{
                backgroundColor: fileUpload ? '#2C73E8' : '#D5D5D5',
                color: fileUpload ? '#FFFFFF' : '#9C9C9C',
                pointerEvents: isLoadingImport ? 'none' : 'auto',
              }}
              onClick={handleUpload}
            >
              <Translate value="library.detailsPortfolios.UP_LOAD" />
            </Element>
          </div>
          <Element
            elementName="p"
            style={{
              color: '#2C73E8',
              lineHeight: '28px',
              cursor: 'pointer',
            }}
            className="whiteSpaceNowrap"
            onClick={handleDownloadTemplate}
          >
            <Translate value="library.detailsPortfolios.DOWNLOAD_TEMPLATE" />
          </Element>
        </div>
      </>
      <ValidateUpload invalidFormatFile={invalidFormatFile} />
      <input
        type="file"
        name="importFile"
        id="importFile"
        onChange={handleSelectFile}
        style={{ display: 'none' }}
      />
    </div>
  )
}
